import React, { useEffect, useRef, useState } from 'react'
import DataTable from '../../component/data_table/DataTable'
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../component/loader/Loader';
import { toast, ToastContainer } from 'react-toastify';
import { activityLogListTodo } from '../../redux/slices/activity-log/ActivityLogList';
import { activitylogPdfTodo } from '../../redux/slices/activity-log/ActivityLogPdf';
import { useFormik } from 'formik';
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { Form } from 'react-bootstrap';
import moment from 'moment/moment';
import SaveButton from '../../component/buttons/SaveButton';
import { Tooltip } from 'react-tooltip';


export default function ActivityLogList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [spiner, setSpiner] = useState(false)
    const [loading, setLoading] = useState(false)
    const activityLog = useSelector(state => state?.activityLogList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(activityLogListTodo()).then((res) => list_res(res))
    }, [bool])

    const list_res = (res) => {
        if (res?.status) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const filterSchema = Yup.object({
        startDate: Yup.string().required("Select From Date"),
        endDate: Yup.string().required("Select To Date"),
    });

    const startDate = useRef();
    const endDate = useRef();

    const initiaValues = {
        startDate: '',
        endDate: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: filterSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            // setLoading(true)
            dispatch(activitylogPdfTodo(values)).then((res) => pdf_res(res))
            // console.log(values)
        }
    })

    const pdf_res = (res) => {
        if (res?.payload?.status == 200) {
            setSpiner(false)
            setBool(!bool)
            startDate.current.flatpickr.clear();
            endDate.current.flatpickr.clear();
            setFieldValue('startDate', '')
            setFieldValue('endDate', '')
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
            startDate.current.flatpickr.clear();
            endDate.current.flatpickr.clear();
            setFieldValue('startDate', '')
            setFieldValue('endDate', '')
        } else if (res?.payload?.status == 404) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
            startDate.current.flatpickr.clear();
            endDate.current.flatpickr.clear();
            setFieldValue('startDate', '')
            setFieldValue('endDate', '')
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }


    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            filter: false,
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false,
        },
        {
            headerName: 'FROM DATE',
            field: 'startDate',
            cellRenderer: params => <span>{new Date(params.value).toLocaleDateString('en-GB')}</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'TO DATE',
            field: 'endDate',
            cellRenderer: params => <span>{new Date(params.value).toLocaleDateString('en-GB')}</span>,
            filter: 'agTextColumnFilter',
            suppressHeaderMenuButton: true,
            sortable: true,
            floatingFilter: false
        },

        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span className='ms-2'
                        type='button'
                        data-tooltip-id='pdf'
                        data-tooltip-content="Activity Log PDF"
                        data-tooltip-place="bottom"
                        onClick={() => window.open(process.env.REACT_APP_IMAGE_URL + params?.data?.link, '_blank')}
                    >
                        <FileText className='text-info' size={20} />
                    </span>
                    <Tooltip id='pdf' className='bg-info tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <div className='layout_head  mb-3'>
                            <h5>Activity Log</h5>
                        </div>
                    </div>
                    <div className="col-md-8 text-end">
                        <Form onSubmit={handleSubmit}>
                            <div className="d-flex justify-content-end">
                                <div className="me-2">
                                    <Flatpickr
                                        className='config_filed form-control flatePicker'
                                        name='startDate'
                                        ref={startDate}
                                        placeholder='From Date'
                                        options={{
                                            altInput: true,
                                            altFormat: "F j, Y",
                                            dateFormat: 'd-m-Y',
                                            allowInput: true,
                                            minDate: '',
                                            maxDate: '',
                                            disable: [],
                                            mode: "single",
                                            defaultDate: [],
                                            conjunction: "",
                                            static: true
                                        }}
                                        onChange={(e) => {
                                            setFieldValue('startDate', moment(e[0]).format("YYYY-MM-DD"))
                                        }}
                                    />
                                    <br />
                                    {errors.startDate && touched.startDate && <span className='text-danger form_label'>{errors.startDate}</span>}
                                </div>
                                <div className="me-2">
                                    <Flatpickr
                                        className='config_filed form-control flatePicker'
                                        name='endDate'
                                        ref={endDate}
                                        placeholder='To Date'
                                        options={{
                                            altInput: true,
                                            altFormat: "F j, Y",
                                            dateFormat: 'd-m-Y',
                                            allowInput: true,
                                            minDate: '',
                                            maxDate: '',
                                            disable: [],
                                            mode: "single",
                                            defaultDate: [],
                                            conjunction: "",
                                            static: true
                                        }}
                                        onChange={(e) => {
                                            setFieldValue('endDate', moment(e[0]).format("YYYY-MM-DD"))
                                        }}
                                    />
                                    <br />
                                    {errors.endDate && touched.endDate && <span className='text-danger form_label'>{errors.endDate}</span>}
                                </div>
                                <div className=''>
                                    <SaveButton name={'FILTER'} spiner={spiner} />
                                </div>
                            </div>
                        </Form>
                    </div>
                    <div className="col-md-12 mt-3">
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={activityLog}
                                columnDefs={columnDefs}
                                height={'60vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}
